import React, { useEffect, useRef, useState } from "react";
import Navbar from "../Navbar/Navbar";
import Shortlist, { SList, mapToSL } from "./Shortlist";
import Selected, { mapToPublish, Publish } from "./Selected";
import "./ShortlistStory.scss";
import Cookies from "js-cookie";
import config from "../../config/apiConfig";
import Loader from "react-spinners/RingLoader";
import { useQuery } from "../../utils/hooks";
import ReactGA from "react-ga";
import { Route, Switch } from "react-router-dom";
import ProducerNav from "../ProducerNav/ProducerNav";

type StoryState = {
    shortlisted: SList[];
    selected: Publish[];
};

const Write: React.FC = () => {
    const query = useQuery();
    const tab = query.get("tab");
    const [menu, setMenu] = useState<number>(tab !== null ? parseInt(tab) : 0);
    const [isLoading, setIsLoading] = useState(false);
    const [state, setState] = useState<StoryState>({
        shortlisted: [],
        selected: [],
    });

    useEffect(() => {
        setIsLoading(true);
        const requestOptions: RequestInit = {
            method: "POST",
            body: null,
            headers: {
                "Access-Control-Allow-Origin": "*",
                session_token: Cookies.get("token") ?? "",
                token: config.token,
            },
        };
        const promise1 = fetch(
            config.BASE_URL + "/v2/api/shortlist/stories",
            requestOptions
        )
            .then((res) => res.json())
            .then(
                (res) =>
                    (res as { [key: string]: any }[]).map((d) => mapToSL(d)) ??
                    []
            );

        const promise2 = fetch(
            config.BASE_URL + "/v2/api/buy/stories",
            requestOptions
        )
            .then((res) => res.json())
            .then(
                (res) =>
                    (res as { [key: string]: any }[]).map((p) =>
                        mapToPublish(p)
                    ) ?? []
            );

        Promise.all([promise1, promise2])
            .then(([shortlisted, selected]) =>
                setState({ shortlisted, selected })
            )
            .finally(() => setIsLoading(false));
    }, []);

    const handleDelete = (id: string) => {
        const requestOptions: RequestInit = {
            method: "POST",
            body: null,
            headers: {
                "Access-Control-Allow-Origin": "*",
                session_token: Cookies.get("token") ?? "",
                token: config.token,
            },
        };
        setIsLoading(true);
        fetch(
            config.BASE_URL + "/v2/api/shortlist/delete?storyId=" + id,
            requestOptions
        )
            .then(() => {
                const shortlisted = [
                    ...state.shortlisted.filter((d) => d.id !== id),
                ];
                setState((s) => ({ ...s, shortlisted }));
            })
            .finally(() => setIsLoading(false));
    };

    const handlePublish = (id: string) => {
        const requestParams = {
            method: "POST",
            body: null,
            headers: {
                "Access-Control-Allow-Origin": "*",
                session_token: Cookies.get("token") ?? "",
                token: config.token,
            },
        };
        setIsLoading(true);
        fetch(config.BASE_URL + "/v2/api/buy/buy?storyId=" + id, requestParams)
            .then(() => {
                const draftToPublish = state.shortlisted.find(
                    (d) => d.id === id
                );
                if (!!!draftToPublish) return;
                const newPublished: Publish = {
                    id: draftToPublish.id,
                    avatar: draftToPublish.avatar,
                    title: draftToPublish.title,
                    updatedAt: new Date(),
                    comments: 0,
                    views: 0,
                };
                const drafts = [
                    ...state.shortlisted.filter((d) => d.id !== id),
                ];
                const published = [newPublished, ...state.selected];
                setState((s) => ({
                    ...s,
                    shortlisted: drafts,
                    selected: published,
                }));
            })
            .finally(() => setIsLoading(false));
    };

    function getItem(): JSX.Element {
        switch (menu) {
            case 0:
                return (
                    <Shortlist
                        drafts={state.shortlisted}
                        publish={handlePublish}
                        delete={handleDelete}
                    />
                );
            case 1:
                return <Selected published={state.selected} />;
        }
        return (
            <Shortlist
                drafts={state.shortlisted}
                publish={handlePublish}
                delete={handleDelete}
            />
        );
    }

    return (
        <div className="shortlists">
            <ProducerNav />
            <div className="header">
                <h2>All shortlisted and Selected stories</h2>
                <div className="tabbar-view">
                    <div
                        className={`tab ${menu == 0 ? "active" : ""}`}
                        onClick={() => setMenu(0)}
                    >
                        Shortlisted
                    </div>
                    <div
                        className={`tab ${menu == 1 ? "active" : ""}`}
                        onClick={() => setMenu(1)}
                    >
                        Selected
                    </div>
                    <div
                        className="tab-indicator"
                        style={{ transform: `translateX(${menu * 130}px)` }}
                    ></div>
                </div>
            </div>
            <div className="body">
                <div className="items-wrapper">
                    {isLoading ? <Loader color="pink" /> : getItem()}
                </div>
            </div>
        </div>
    );
};

export default Write;
